export default __webpack_public_path__ + "static/media/337.8a9800f0.jpg";